// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"a766f222","73":"38a99cd3","435":"bfe3fe9d"}[chunkId] + ".chunk.js";
};